import { render } from "./DashboardCRS.vue?vue&type=template&id=ff24f330&scoped=true"
import script from "./DashboardCRS.vue?vue&type=script&lang=js"
export * from "./DashboardCRS.vue?vue&type=script&lang=js"

import "./DashboardCRS.vue?vue&type=style&index=0&id=ff24f330&scoped=true&lang=css"

import exportComponent from "/harness/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff24f330"]])

export default __exports__